import { render } from "./ScrollContainerComponent.vue?vue&type=template&id=044fd9fe&scoped=true"
const script = {}

import "./ScrollContainerComponent.vue?vue&type=style&index=0&id=044fd9fe&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044fd9fe"]])

export default __exports__